angular.module('core')
  .service('edxAcademicMappingsApi', [
    'cancelableResourceFactory',
    'cancelableResourceManager',
    'authentication',
    '$q',
    function ($cancelableResourceFactory, $cancelableResourceManager, authentication, $q) {
      var self = this;

      self.ACADEMIC_PROGRAM = 'PROGRAM';
      self.ACADEMIC_STANDARD = 'STANDARD';
      self.THIRD_PARTY_ASSESSMENT = 'THIRD_PARTY_ASSESSMENT';
      self.getAcademicMappings = getAcademicMappings;
      self.getAcademicMappingByName = getAcademicMappingByName;
      self.getAcademicStandardsForDistrict = getAcademicStandardsForDistrict;
      self.getThirdPartyAssessments = getThirdPartyAssessments;

      // Short descriptions of ASTs added for Assign Focus IN-3022.
      // These should live in the academic_standards table (See IN-3177).
      var nameToShortDescriptionMap = {
        alabama: "Alabama",
        alabama_2019: "Alabama 2019",
        alaska: "Alaska",
        arizona: "Arizona",
        arkansas: "Arkansas",
        bluebonnet: 'Texas Bluebonnet',
        california: "California",
        colorado: "Colorado",
        colorado_2020: "Colorado 2020",
        connecticut: "Connecticut",
        ccss: "CCSS",
        dbl: "DreamBox Units",
        delaware: "Delaware",
        florida: "MAFS",
        florida_best: "Florida B.E.S.T.",
        georgia: "GSE",
        georgia_2015: "GSE 2015",
        georgia_2021: "Georgia 2021",
        hawaii: "Hawaii",
        idaho: "Idaho",
        illinois: "Illinois",
        indiana: "Indiana",
        iowa: "Iowa",
        kansas: "Kansas Math 2010",
        kansas_2017: "Kansas Math 2017",
        kentucky: "Kentucky",
        knotion: "Knotion",
        knotion_2023: "Knotion 2023",
        louisiana: "Louisiana",
        maine: "Maine",
        manitoba: "Manitoba",
        maryland: "Maryland",
        massachusetts: "Massachusetts",
        michigan: "Michigan",
        minnesota: "Minnesota",
        mississippi: "Mississippi",
        missouri: "Missouri",
        montana: "Montana",
        nebraska: "Nebraska",
        nevada: "Nevada",
        new_hampshire: "New Hampshire",
        new_jersey: "New Jersey",
        new_mexico: "New Mexico",
        new_york: "New York",
        north_carolina: "North Carolina",
        north_dakota: "North Dakota",
        ohio: "Ohio",
        oklahoma: "Oklahoma",
        ontario: "Ontario",
        ontario_2020: "Ontario 2020",
        oregon: "Oregon",
        oregon_2021: "Oregon 2021",
        pennsylvania: "Pennsylvania",
        rhode_island: "Rhode Island",
        scarolina: "South Carolina",
        sol: "VA SOL 2009",
        sol_2016: "VA SOL 2016",
        south_dakota: "South Dakota",
        teks: "TEKS",
        tennessee: "Tennessee",
        uk_standards_2013: "England",
        utah: "Utah",
        vermont: "Vermont",
        washington: "Washington",
        west_virginia: "West Virginia",
        wisconsin: "Wisconsin",
        wnlp: "WNCP",
        wyoming: "Wyoming",
        cflm: "CFLM",
        cflm_2021: "CFLM 2021",
        engageNY: "EngageNY",
        eureka: "Eureka",
        eureka_2023: "Eureka 2023",
        quebec: "Quebec",
        nwea: "NWEA®",
        gomath: "GO Math!",
        gomath_2023: "GO Math! 2023",
        envmath2: "enVisionmath2.0",
        origo: "Origo",
        bridges: "Bridges",
        mathexpressions: "Math Expressions",
        investigations: "Investigations",
        everydaymath_3rd: "Everyday Math 3rd",
        everydaymath_4th: "Everyday Math 4th",
        illustrative_math: "Illustrative Math",
        wisconsin_2021: "Wisconsin 2021",
        tennessee_2023: "Tennessee 2023",
        indiana_2023: "Indiana 2023",
        arkansas_2023: "Arkansas 2023",
        south_dakota_2019: "South Dakota 2019",
        nebraska_2022: "Nebraska 2022",
        oklahoma_2022: "Oklahoma 2022",
        rhode_island_2021: "Rhode Island 2021",
        british_columbia_2020: "British Columbia 2020",
        alberta_2020: "Alberta 2020",
        nova_scotia_2019: "Nova Scotia 2019",
        bermuda_2022: "Bermuda 2022",
        connected_math: "Connected Math",
        big_ideas_math: "Big Ideas Math",
        into_math: "Into Math",
        math_expressions: "Math Expressions",
        revealmath: "Reveal Math",
        north_dakota_2023: "North Dakota 2023",
        new_jersey_2023: "New Jersey 2023",
        sol_2023: "VA SOL 2023",
        eureka_texas: "Eureka Texas Edition",
        experience_math: "Experience Math",
        bridges_3: "Bridges 3rd Edition",
        ready_math: "Ready Math",
        scarolina_2025: "South Carolina 2025",
        arizona_2025: "Arizona 2025",
        amplify_desmos: "Amplify Desmos",
        maryland_2025: "Maryland 2025",
        minnesota_2022: "Minnesota 2022",
        cambridge: "Cambridge"
      };

      var AcademicMappings = $cancelableResourceFactory.createCacheableResource(null, '/m/academic_mappings', { academic_type: '@academic_type' }, {
        get: {
          cache: true,
          method: 'GET',
          isArray: true
        }
      });

      var DistrictAcademicStandards = $cancelableResourceFactory.createCacheableResource(
        'DistrictAcademicStandards',
        '/api/v1/districts/:districtId/academicstandards',
        {},
        {
          get: {
            cache: true,
            method: 'GET'
          }
        });

      var ThirdPartyAssessments = $cancelableResourceFactory.createCacheableResource(
        'ThirdPartyAssessments',
        '/api/v1/districts/:districtId/thirdpartyassessments',
        {},
        {
          get: {
            cache: true,
            method: 'GET'
          }
        });


      /**************************************************************/
      /*                          Api                               */
      /**************************************************************/

      function getAcademicMappings(academicType) {
        var resource = AcademicMappings.get({ academic_type: academicType });
        $cancelableResourceManager.addAndRemoveOnFinish(resource);

        var mappingsWithShortDescriptionsPromise = resource.$promise.then(function (academicMappings) {
          _.each(academicMappings, function (academicMapping) {
            academicMapping.shortDesc = nameToShortDescriptionMap[academicMapping.name];
          });

          return academicMappings;
        });

        return mappingsWithShortDescriptionsPromise;
      }

      function getAcademicMappingByName(name) {
        // It would be nice to cache this
        return getAcademicMappings()
          .then(function (results) {
            var mapping = _.find(results, function (mapping) {
              return mapping.name === name;
            });
            if (mapping) {
              return mapping;
            } else {
              return $q.reject();
            }
          });
      }

      function getAcademicStandardsForDistrict(districtId) {
        var resource = DistrictAcademicStandards.get({ districtId: districtId });
        $cancelableResourceManager.addAndRemoveOnFinish(resource);

        var standardsWithShortDescriptionsPromise = resource.$promise.then(function (academicMappings) {
          _.each(academicMappings.academic_standards, function (academicMapping) {
            academicMapping.shortDesc = nameToShortDescriptionMap[academicMapping.name];
          });

          return academicMappings.academic_standards;
        });

        return standardsWithShortDescriptionsPromise;
      }

      function getThirdPartyAssessments() {
        var resource = ThirdPartyAssessments.get({ districtId: authentication.getCustomer().district_id });
        $cancelableResourceManager.addAndRemoveOnFinish(resource);

        return resource.$promise.then(function (result) {
          return result.mappings;
        });
      }
    }]);
